import { Routes } from '@angular/router';

export enum MySustainabilityRouteNames {
  GREENCHAIN = 'greenchain',
  SUSTAINABILITY_CERTIFICATES = 'sustainability-certificates',
}

export const MY_SUSTAINABILITY_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('@pages/sustainability/sustainability.page').then((p) => p.SustainabilityPage),
  },
  {
    path: MySustainabilityRouteNames.SUSTAINABILITY_CERTIFICATES,
    loadComponent: () =>
      import('@pages/sustainability/sustainability-certificates/sustainability-certificates.page').then(
        (p) => p.SustainabilityCertificatesPage
      ),
    data: {
      breadcrumb: 'SUSTAINABILITY.CERTIFICATES.TITLE',
    },
  },
  {
    path: MySustainabilityRouteNames.GREENCHAIN,
    loadComponent: () => import('@pages/sustainability/greenchain/greenchain.page').then((p) => p.GreenchainPage),
    data: {
      breadcrumb: 'SUSTAINABILITY.GREENCHAIN',
    },
  },
];
